export function getNestedPropValue(
  sourceObject: unknown,
  dotNotationPath?: string
) {
  if (!dotNotationPath || !sourceObject) {
    return undefined;
  }

  let iterationData = sourceObject;

  for (const subPath of dotNotationPath.split(".")) {
    if (!subPath || !iterationData) {
      return undefined;
    }

    if (typeof iterationData === "object") {
      if (
        typeof iterationData[subPath as keyof typeof iterationData] === "string"
      ) {
        return iterationData[subPath as keyof typeof iterationData];
      }

      iterationData = iterationData[subPath as keyof typeof iterationData];
    }
  }
  return iterationData;
}
